import { getProps } from '../props'
import create from '../Services/create'
import update from '../Services/update'

export default async (values, dispatch) => {

  const { onClose, didCreate, didUpdate } = getProps()

  if (!values.id) {

    const timesheet = await dispatch(create(values))

    onClose()
    
    if (didCreate) didCreate(timesheet)

  } else {

    const timesheet = await dispatch(update(values))

    onClose()
    
    if (didUpdate) didUpdate(timesheet)

  }

}
